module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-2-nad_600px_width-0_1.2f9aff65.png";